// extracted by mini-css-extract-plugin
module.exports = {"badge":"badge-skins-mediumOnWide-badge-f18bc148"};